/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_Summary_PcInputs */

const en_pc_cmp_summary_pc = /** @type {(inputs: Pc_Cmp_Summary_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Best for reading, commenting, forms and page organizing. Free, private, and available on every desktop including Linux.`)
};

const zh_pc_cmp_summary_pc = /** @type {(inputs: Pc_Cmp_Summary_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最适合阅读、批注、表单和页面整理。免费、私密，覆盖包括 Linux 在内的所有桌面系统。`)
};

/**
* | output |
* | --- |
* | "Best for reading, commenting, forms and page organizing. Free, private, and available on every desktop including Linux." |
*
* @param {Pc_Cmp_Summary_PcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_summary_pc = /** @type {((inputs?: Pc_Cmp_Summary_PcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_Summary_PcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_summary_pc(inputs)
	return zh_pc_cmp_summary_pc(inputs)
});
export { pc_cmp_summary_pc as "pc.cmp.summary_pc" }